import { createSlice } from '@reduxjs/toolkit';

import BonusRepository from '../../repositories/Admin/Memberships/BonusRepository';
import { createRestSlice } from '../../utils/RestSlice';

const bonusesRestSlice = createRestSlice({
  resource: 'bonuses',
  repository: BonusRepository,
  slices: ['loadBonuses'],
});

const initialState = {
  ...bonusesRestSlice.initialState,
};

const bonusesSlice = createSlice({
  name: 'bonuses',
  initialState,
  reducers: {
    ...bonusesRestSlice.reducers,
  },
});

export default bonusesSlice.reducer;

export const bonusesRestHooks = bonusesRestSlice.hooks(bonusesSlice, [
  'admin',
  'BonusesSlice',
]);
